import { SuperSpaceService } from "@/services/superSpace/superSpace.service";
const _superSpaceService = new SuperSpaceService();

const setSuperSpaceAction = ({ commit }, payload): void => {
  commit("setSuperSpace", payload);
};
const setSuperSpacesAction = ({ commit }, data): void => {
  commit("setSuperSpaces", data);
};
const setSuperSpacesAvailablePageAction = ({ commit }, data): void => {
  commit("setSuperSpacesAvailablePage", data);
};
const setLastPageSuperSpacesAction = ({ commit }, data): void => {
  commit("setLastPageSuperSpaces", data);
};

const setSpacesAction = (
  { commit },
  { data, callback, callbackError }
): void => {
  _superSpaceService
    .setSpaces(data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSuperSpacesAction = (
  { commit, state },
  { name = null, pagination = false, callback, callbackError }
): void => {
  _superSpaceService
    .getSuperSpaces(name, pagination, state.superSpacesAvailablePage)
    .then((response) => {
      if (pagination) {
        commit("addSuperSpaces", response.data);
        if (
          state.superSpacesAvailablePage <=
          parseInt(response.headers["pagination-last-page"])
        )
          commit(
            "setSuperSpacesAvailablePage",
            state.superSpacesAvailablePage + 1
          );
        commit(
          "setLastPageSuperSpaces",
          parseInt(response.headers["pagination-last-page"])
        );
        callback(response);
      } else {
        callback(response);
        commit("addSuperSpaces", response.data);
      }
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateSuperSpaceAction = (
  { commit },
  { superSpaceId, payload, callback, callbackError }
): void => {
  _superSpaceService
    .updateSuperSpace(superSpaceId, payload)
    .then((response) => {
      commit("setSuperSpace", response.data);
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error.response);
    });
};

const getSuperSpaceByIdAction = (
  { commit },
  { superSpaceId, callback, callbackError }
): void => {
  _superSpaceService
    .getSuperSpaceById(superSpaceId)
    .then((response) => {
      commit("setSuperSpace", response.data);
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const uploadSuperSpaceFileAction = (
  { commit },
  { data, callback, callbackError }
): void => {
  _superSpaceService
    .uploadSuperSpaceFile(data)
    .then((response) => callback(response.data))
    .catch((error) => {
      callbackError(error);
    });
};

const addFavouriteAction = (
  { commit },
  { id, data, callback, callbackError }
): void => {
  _superSpaceService
    .addFavourite(id, data)
    .then((response) => {
      commit("updateSuperSpaceFavorite", response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getNumberOfUsersInMultiWebinarAction = (
  { commit },
  { superSpaceId, callback }
): void => {
  _superSpaceService
    .getNumberOfUsersInMultiWebinar(superSpaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSuperSpaceUsersInMultiWebinarAction = (
  { commit },
  { superSpaceId, page, search, callback }
): void => {
  _superSpaceService
    .getSuperSpaceUsersInMultiWebinar(superSpaceId, page, search)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const changeSuperSpaceWebinarModeAction = (
  { commit },
  { superSpaceId, data, callback, callbackError }
): void => {
  _superSpaceService
    .changeSuperSpaceWebinarMode(superSpaceId, data)
    .then((response) => {
      commit(
        "changeMultiWebinarInStore",
        response.data.isMultiWebinarActivated
      );
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateDiaryAction = ({ commit }, { superSpaceId, data, callback }) => {
  _superSpaceService
    .updateDiary(superSpaceId, data)
    .then((response) => {
      callback();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getDiaryAction = ({ commit }, { superSpaceId, callback }) => {
  _superSpaceService
    .getDiary(superSpaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSuperSpacesByIdAction = ({ commit }, { superSpaceId, callback, callbackError }) => {
  _superSpaceService
    .getSuperSpaceById(superSpaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateSuperSpacesAction = ({ commit }, { superSpaceId, data, callback, callbackError }) => {
  _superSpaceService
    .updateSuperSpaces(superSpaceId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSuperSpaceTagAction = ({ commit }, { superSpaceId, filter, callback, callbackError }) => {
  _superSpaceService
    .getSuperSpaceTag(superSpaceId, filter)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removeImageSuperSpaceAction = ({ commit }, { imageId, callback, callbackError }) => {
  _superSpaceService
    .removeImageSuperSpace(imageId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getPhysicalPlantAndRoomsAction = ({ commit }, { superSpaceId, data, callback, callbackError }) => {
  _superSpaceService
    .getPhysicalPlantAndRooms(superSpaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createPhysicalPlantAction = ({ commit }, { superSpaceId, data, callback, callbackError }) => {
  _superSpaceService
    .createPhysicalPlant(superSpaceId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createPhysicalRoomAction = ({ commit }, { plantId, data, callback, callbackError }) => {
  _superSpaceService
    .createPhysicalRoom(plantId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createPhysicalImageAction = (
  { commit },
  { plantId, data, callback, callbackError }
): void => {
  _superSpaceService
    .createPhysicalImage(plantId, data)
    .then((response) => { 
      callback(response.data) 
    })
    .catch((error) => {
      callbackError(error);
    });
};

const editPhysicalPlantAction = ({ commit }, { plantId, data, callback, callbackError }) => {
  _superSpaceService
    .editPhysicalPlant(plantId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removePhysicalPlantAction = ({ commit }, { plantId, callback, callbackError }) => {
  _superSpaceService
    .removePhysicalPlant(plantId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removePhysicalRoomAction = ({ commit }, { roomId, callback, callbackError }) => {
  _superSpaceService
    .removePhysicalRoom(roomId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const editPhysicalRoomAction = ({ commit }, { roomId, data, callback, callbackError }) => {
  _superSpaceService
    .editPhysicalRoom(roomId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setSpaceDefaultAction = ({ commit }, { superSpaceId, spaceId, callback, callbackError }) => {
  _superSpaceService
    .setSpaceDefault(superSpaceId, spaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setFeaturePlanAction = ({ commit }, { superSpaceId, data, callback, callbackError }) => {
  _superSpaceService
    .setFeaturePlan(superSpaceId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

export default {
  setSpacesAction,
  getSuperSpacesAction,
  updateSuperSpaceAction,
  setSuperSpaceAction,
  getSuperSpaceByIdAction,
  uploadSuperSpaceFileAction,
  addFavouriteAction,
  setSuperSpacesAction,
  setSuperSpacesAvailablePageAction,
  setLastPageSuperSpacesAction,
  getSuperSpaceUsersInMultiWebinarAction,
  changeSuperSpaceWebinarModeAction,
  getNumberOfUsersInMultiWebinarAction,
  updateDiaryAction,
  getDiaryAction,
  getSuperSpacesByIdAction,
  updateSuperSpacesAction,
  getSuperSpaceTagAction,
  removeImageSuperSpaceAction,
  getPhysicalPlantAndRoomsAction,
  createPhysicalPlantAction,
  createPhysicalRoomAction,
  editPhysicalPlantAction,
  removePhysicalPlantAction,
  createPhysicalImageAction,
  removePhysicalRoomAction,
  editPhysicalRoomAction,
  setSpaceDefaultAction,
  setFeaturePlanAction,
};
